import {
  DebouncedTextInput,
  GroupTitle,
  useWorkflowInput,
} from "ra-friendsofbabba";

import { Group } from "ra-friendsofbabba";
import { GroupItem } from "ra-friendsofbabba";
import MunicipalityInput from "../../component/input/MunicipalityInput";
import ProvinceInput from "../../component/input/ProvinceInput";
import React, { useMemo } from "react";
import { usePermissions, useTranslate } from "react-admin";

const DISABLE_IMPORTED_FIELDS = true;

const DataInput = ({ ...props }) => {
  const { loaded, permissions } = usePermissions();
  const isResearcher = useMemo(
    () => loaded && permissions(["researcher"]),
    [loaded, permissions]
  );
  const type = props.source.replace("_data", "");
  const translate = useTranslate();
  const fieldSource = (name) => `${type}_${name}`;
  const { resource, source, record } = props;
  const { visible, disabled } = useWorkflowInput({
    resource,
    source,
    record,
  });
  if (!visible) {
    return null;
  }

  return (
    <Group {...props} wrapper>
      <GroupTitle
        title={translate(`resources.executive-projects.section.${type}`)}
      />

      <Group>
        <GroupItem lg={6}>
          <DebouncedTextInput
            disabled={disabled || DISABLE_IMPORTED_FIELDS}
            source={fieldSource("name")}
          />
        </GroupItem>

        {type === `public` && (
          <GroupItem lg={6}>
            <DebouncedTextInput
              disabled={disabled || DISABLE_IMPORTED_FIELDS}
              source={fieldSource("operative_unit")}
            />
          </GroupItem>
        )}

        <GroupItem lg={6}>
          <DebouncedTextInput
            disabled={disabled || isResearcher}
            source={fieldSource("referent_name")}
          />
        </GroupItem>
        <GroupItem lg={6}>
          <DebouncedTextInput
            disabled={disabled || isResearcher}
            source={fieldSource("referent_email")}
            type="email"
          />
        </GroupItem>
      </Group>
      <Group>
        <GroupItem lg={2} md={2}>
          <ProvinceInput
            disabled={disabled}
            source={fieldSource("province")}
            filter={{ region: "Puglia" }}
          />
        </GroupItem>
        <GroupItem lg={4} md={4}>
          <MunicipalityInput
            disabled={disabled}
            source={fieldSource("municipality_id")}
            filter={{ region: "Puglia" }}
            deps={{ province: fieldSource("province") }}
          />
        </GroupItem>
      </Group>
    </Group>
  );
};
export default DataInput;
